import { siteName } from 'config/site';
import React from 'react';
import { Box, Typography } from '@mui/material';
import { Link } from 'react-router-dom';

export const logoSrc = `${process.env.PUBLIC_URL}/android-chrome-192x192.png`;

/** App logo mark only (PNG from public/). */
export function LogoMark({ size = 28, sx, alt = siteName }) {
  return (
    <Box
      component="img"
      src={logoSrc}
      alt={alt}
      sx={{
        width: size,
        height: size,
        borderRadius: 1.25,
        objectFit: 'contain',
        display: 'block',
        flexShrink: 0,
        ...sx,
      }}
    />
  );
}

/**
 * Logo + optional site name. Pass `to` for a router link wrapper.
 */
const SiteLogo = ({
  size = 28,
  showText = true,
  gradientText = false,
  textVariant = 'h6',
  to,
  sx,
  textSx,
}) => {
  const content = (
    <>
      <LogoMark size={size} />
      {showText && (
        <Typography
          variant={textVariant}
          sx={{
            fontWeight: gradientText ? 700 : 800,
            lineHeight: 1.2,
            ...(gradientText
              ? {
                  background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                  WebkitBackgroundClip: 'text',
                  WebkitTextFillColor: 'transparent',
                }
              : { color: 'text.primary' }),
            ...textSx,
          }}
        >
          {siteName}
        </Typography>
      )}
    </>
  );

  const boxSx = {
    display: 'inline-flex',
    alignItems: 'center',
    gap: 1,
    textDecoration: 'none',
    color: 'inherit',
    ...sx,
  };

  if (to) {
    return (
      <Box component={Link} to={to} sx={boxSx}>
        {content}
      </Box>
    );
  }

  return <Box sx={boxSx}>{content}</Box>;
};

export default SiteLogo;
